<template>
  <td class="shipmentPallet" style="vertical-align: top; text-align: left;">
    <div>
      <v-tooltip top open-delay="500">
        <template v-slot:activator="{ on }">
          <div :class="palletClass(pallet)" @click="selectPallet(pallet)" v-on="on">
            <div style="display: inline;">{{ palletNumberTitle }}</div>
            <span style="float: right; color: #707070;">{{ stateLabel(pallet.state) }}</span>
            <v-divider style="padding-bottom: 5px;"/>
            <PalletItems v-if="pallet.items" :items="pallet.items" no-planned-amount="true"/>
          </div>
        </template>
        <span><div v-html="palletTitle(pallet)"></div></span>
      </v-tooltip>
    </div>
  </td>
</template>

<script>
import PalletItems from '../components/PalletItems'
import NumberUtil from '../assets/javascript/numberutil'

export default {
  name: 'ShipmentLooseGoods',
  components: { PalletItems, NumberUtil },
  props: {
    value: Object,
    pallet: Object,
    palletSelected: Object
  },
  created: function () {
  },
  data () {
    return {
    }
  },
  methods: {
    stateLabel: function (state) {
      switch (state) {
        case 'PLANNED': return 'Planned'
        case 'IN_PRODUCTION': return 'In production'
        case 'PRODUCED': return 'Produced'
        case 'READY_FOR_PICKUP': return 'Ready for pickup'
        case 'IN_TRANSPORT': return 'In transport'
        case 'REPACKED': return 'Repacked'
        case 'DELIVERED': return 'Delivered'
      }
      return 'Unknown'
    },
    isSelected: function (pallet) {
      return this.palletSelected && this.palletSelected.id === pallet.id
    },
    palletClass: function (pallet) {
      return 'shipmentPallet clickable' + (this.isSelected(pallet) ? ' selected' : '')
    },
    palletTitle: function (pallet) {
      let palletTitle = '<table class="palletTooltip">'
      if (pallet.number !== pallet.palletNumber) {
        palletTitle += '<tr><td>Number:</td><td>' + pallet.number + '</td></tr>'
      }
      palletTitle += '<tr><td>Supplier:</td><td>' + (pallet.supplier && pallet.supplier.name ? pallet.supplier.name : '') + '</td></tr>'
      palletTitle += '<tr><td>Field:</td><td>' + (pallet.field && pallet.field.address && pallet.field.address ? pallet.field.address.nameAndText : '') + '</td></tr>'
      palletTitle += '<tr><td>Contractor:</td><td>' + (pallet.contractor && pallet.contractor.name ? pallet.contractor.name : '') + '</td></tr>'
      if (pallet.location && pallet.location.nameAndText) {
        palletTitle += '<tr><td>Location:</td><td>' + (pallet.location && pallet.location.nameAndText ? pallet.location.nameAndText : '') + '</td></tr>'
      }
      palletTitle += '<tr><td style="padding-right: 5px;">Loading address:</td><td>' + (pallet.pickupAddress && pallet.pickupAddress.nameAndText ? pallet.pickupAddress.nameAndText : '') + '</td></tr>'
      if (pallet.internalCarrier && pallet.internalCarrier.name) {
        palletTitle += '<tr><td>Internal carrier:</td><td>' + (pallet.internalCarrier && pallet.internalCarrier.name ? pallet.internalCarrier.name : '</td></tr>')
      }
      if (pallet.state === 'DELIVERED' && pallet.deliveryComment && pallet.deliveryComment !== '') {
        palletTitle += '<tr><td>Delivery comment:</td><td><div style="white-space: pre;">' + pallet.deliveryComment + '</div></td></tr>'
      }
      palletTitle += '</table>'
      return palletTitle
    },
    selectPallet: function (pallet) {
      if (this.isSelected(pallet)) {
        this.$emit('change', { pallet: null })
      } else {
        this.$emit('change', { pallet: pallet })
      }
    }
  },
  computed: {
    palletNumberTitle: function () {
      return (NumberUtil.isZeroOrPositiveInteger(this.pallet.palletNumber) ? 'Pallet #' : '') + this.pallet.palletNumber
    }
  }
}
</script>

<style scoped>
  div.shipmentPallet {
    padding: 5px;
    border: 1px solid #bbbbbb;
    border-radius: 4px;
    min-height: 50px;
  }
  div.clickable {
    cursor: pointer;
  }
  div.selected {
    background-color: rgba(0, 77, 64, 0.1);
    border: 1px solid #606060;
  }
</style>



// WEBPACK FOOTER //
// src/components/ShipmentLooseGoods.vue